import React from 'react';
import { motion } from 'framer-motion';
import { ProductMockup } from './ProductMockup';
export function Bonuses() {
  return <section className="bg-crema text-bordo py-20 px-4 md:px-8" data-id="element-39">
      <div className="max-w-5xl mx-auto" data-id="element-40">
        <div className="text-center mb-16" data-id="element-41">
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-6" data-id="element-42">
            Y además incluye bonos pensados para que uses el producto de verdad:
          </h2>
          <div className="inline-block bg-bordo text-dorado font-bold px-6 py-2 rounded-full text-xl animate-pulse" data-id="element-43">
            GRATIS POR EL DÍA DE HOY
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-44">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="flex flex-col md:flex-row items-center gap-6 bg-white p-6 rounded-2xl shadow-lg" data-id="element-45">
            <div className="shrink-0" data-id="element-46">
              <ProductMockup title="Bono 1: +30 Recetas" isBonus={true} data-id="element-47" />
            </div>
            <div data-id="element-48">
              <h3 className="text-2xl font-serif font-bold mb-3" data-id="element-49">
                Bono 1: +30 recetas rápidas
              </h3>
              <p className="text-gray-700" data-id="element-50">
                Ideas simples, prácticas y sabrosas para esos días donde no
                querés pensar.
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="flex flex-col md:flex-row items-center gap-6 bg-white p-6 rounded-2xl shadow-lg" data-id="element-51">
            <div className="shrink-0" data-id="element-52">
              <ProductMockup title="Bono 2: Guarniciones" isBonus={true} data-id="element-53" />
            </div>
            <div data-id="element-54">
              <h3 className="text-2xl font-serif font-bold mb-3" data-id="element-55">
                Bono 2: Guía de guarniciones perfectas
              </h3>
              <p className="text-gray-700" data-id="element-56">
                Porque una buena milanesa mejora cuando la acompañás bien.
                Papas, ensaladas, purés, arroz, verduras, opciones rápidas y
                combinaciones ganadoras.
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="flex flex-col md:flex-row items-center gap-6 bg-white p-6 rounded-2xl shadow-lg" data-id="element-57">
            <div className="shrink-0" data-id="element-58">
              <ProductMockup title="Bono 3: Meal Prep" isBonus={true} data-id="element-59" />
            </div>
            <div data-id="element-60">
              <h3 className="text-2xl font-serif font-bold mb-3" data-id="element-61">
                Bono 3: Organización semanal y meal prep
              </h3>
              <p className="text-gray-700" data-id="element-62">
                Para preparar, freezar, planificar y resolver comidas durante la
                semana sin vivir improvisando.
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.3
        }} className="flex flex-col md:flex-row items-center gap-6 bg-white p-6 rounded-2xl shadow-lg" data-id="element-63">
            <div className="shrink-0" data-id="element-64">
              <ProductMockup title="Bono 4: Cortes" isBonus={true} data-id="element-65" />
            </div>
            <div data-id="element-66">
              <h3 className="text-2xl font-serif font-bold mb-3" data-id="element-67">
                BONO 4: Guía de los mejores cortes y cómo cocinarlos
              </h3>
              <p className="text-gray-700" data-id="element-68">
                Aprende a elegir la carne perfecta para cada ocasión y
                presupuesto.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}